// MOBILE DETECT
export function createDarkPattern(patternConfig) {
	return {
		type: "CREATE_DARK_PATTERN",
		patternConfig
	};
}

export function destroyDarkPattern(id, location) {
	const soundnum = Math.floor(Math.random() * 4 + 1).toString()
	return {
		type: "DESTROY_DARK_PATTERN",
		location,
		id,
		meta: { sound: `destroyAd${soundnum}`, op: "playFx" }
	};
}
export function removeDarkPattern(id, location) {
	return {
		type: "DESTROY_DARK_PATTERN",
		location,
		id
	};
}

export function createDarkPattern2d(patternConfig) {
	return {
		type: "CREATE_DARK_PATTERN2D",
		patternConfig
	};
}



// WEBPACK FOOTER //
// ./src/actions/darkPatterns.js